<template>
<v-text-field ref="dateInput" v-model="displayDate" :label="label" :rules="dateRules" maxlength="10" prepend-inner-icon="mdi-calendar-text" @input="onInput" @focus="fillTodayIfEmpty" @blur="onBlur" @keydown="handleKey" @keypress="allowOnlyNumbers"
  v-bind="$attrs" />
</template>

<script>
import moment from 'moment-jalaali'

moment.loadPersian({
  usePersianDigits: false
})

export default {
  name: 'JalaliDateInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'تاریخ'
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      displayDate: ''
    }
  },

  mounted() {
    if (this.isValidJalali(this.defaultValue)) {
      this.displayDate = this.defaultValue
      this.$emit('input', this.defaultValue)
    } else if (this.isValidJalali(this.value)) {
      this.displayDate = this.value
    } else {
      this.displayDate = ''
      this.$emit('input', '')
    }
  },

  computed: {
    dateRules() {
      return [
        v => !!v || 'الزامی',
        v => this.isValidJalali(v) || 'تاریخ شمسی نامعتبر'
      ]
    }
  },

  watch: {
    value(val) {
      if (val !== this.displayDate) {
        this.displayDate = val || ''
      }
    },

    defaultValue(val) {
      if (!this.value && val) {
        this.displayDate = val
        this.$emit('input', val)
      }
    }
  },

  methods: {
    // ---------- Input ----------
    onInput(val) {
      const input = this.$refs.dateInput?.$el?.querySelector('input')
      if (!input) return

      const raw = (val || '').replace(/\D/g, '').slice(0, 8)

      let formatted = ''
      if (raw.length <= 4) {
        formatted = raw
      } else if (raw.length <= 6) {
        formatted = raw.slice(0, 4) + '/' + raw.slice(4)
      } else {
        formatted =
          raw.slice(0, 4) +
          '/' +
          raw.slice(4, 6) +
          '/' +
          raw.slice(6)
      }

      this.displayDate = formatted
      this.$emit('input', formatted)

      this.$nextTick(() => {
        input.setSelectionRange(formatted.length, formatted.length)
      })
    },

    // ---------- Blur ----------
    onBlur() {
      if (!this.isValidJalali(this.displayDate)) {
        this.displayDate = ''
        this.$emit('input', '')
      }
    },

    // ---------- Focus ----------
    fillTodayIfEmpty() {
      if (!this.displayDate) {
        const today = moment().format('jYYYY/jMM/jDD')
        this.displayDate = today
        this.$emit('input', today)
      }
    },

    // ---------- Hotkeys ----------
    handleKey(e) {
      if (e.key === '+' || e.key === '=') {
        e.preventDefault()
        this.addDay(1)
      } else if (e.key === '-' || e.key === '_') {
        e.preventDefault()
        this.addDay(-1)
      }
    },

    addDay(days) {
      if (!this.isValidJalali(this.displayDate)) return

      this.displayDate = moment(this.displayDate, 'jYYYY/jMM/jDD')
        .add(days, 'day')
        .format('jYYYY/jMM/jDD')

      this.$emit('input', this.displayDate)
    },

    // ---------- Validation ----------
    isValidJalali(date) {
      if (!date || date.length !== 10) return false

      const parts = date.split('/')
      if (parts.length !== 3) return false

      const [jy, jm, jd] = parts.map(n => parseInt(n, 10))
      if (jm < 1 || jm > 12) return false

      const daysInMonth =
        jm <= 6 ?
        31 :
        jm <= 11 ?
        30 :
        moment.jIsLeapYear(jy) ?
        30 :
        29

      if (jd < 1 || jd > daysInMonth) return false

      return moment(date, 'jYYYY/jMM/jDD', true).isValid()
    },

    // ---------- Key Filter ----------
    allowOnlyNumbers(e) {
      const allowedKeys = [
        'Backspace',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Home',
        'End',
      ]

      if (allowedKeys.includes(e.key)) return

      if (!/[0-9]/.test(e.key)) {
        e.preventDefault()
      }
    }
  }
}
</script>
